(ns practitest.frontend.version-updates.views
  (:require
   [practitest.frontend.common.i18n :as i18n]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.version-updates.events :as events]
   [practitest.frontend.version-updates.subs :as subs]
   [re-frame.core :as re-frame]))

(defn critical-update-modal []
  (let [version-update @(re-frame/subscribe [::subs/version-update])
        show? (= (:type version-update) "CRITICAL")]
    [modal/bootstrap-modal
     {:is-open? show?
      :class "force-modal danger-modal"
      :close-button? false
      :centered? true
      :on-request-close #()}

     (i18n/get-translation "version_update.critical.title" "Critical Update Required")

     [:div.text-center
      [:div
       (i18n/get-translation 
         "version_update.critical.default_message"
         "This version contains important updates and critical bug fixes that must be applied. Please refresh your browser now to ensure system stability")]]

     [:div.d-flex.justify-content-center
      [buttons/button
       {:primary? true
        :on-click #(re-frame/dispatch [::events/refresh-page])
        :test-id "critical-update-refresh-button"
        :text (i18n/get-translation "version_update.critical.refresh" "Refresh Now")}]]]))

(defn- non-critical-update-notification []
  (notifications/notify!
   [:<>
    [:span (i18n/get-translation "version_update.non_critical.default_message"
                                 "New version available! We've made improvements and fixed bugs. Please save your work first, then refresh to enjoy the latest updates.")]
    [buttons/button
     {:primary? true
      :on-click #(re-frame/dispatch [::events/refresh-page])
      :text (i18n/get-translation "generic.button.refresh" "Refresh")}]]
   {:type "info"
    :id "version-update-notification"
    :auto-close false
    :dismissible false}))

(defn- critical-update-with-unsaved-changes []
  (notifications/notify!
   [:<>
    [:span (i18n/get-translation "version_update.critical.unsaved_changes_message"
                                 "This version contains important updates and critical bug fixes, but you have unsaved changes. Please save your work first, then refresh to enjoy the latest updates.")]
    [buttons/button
     {:class "warning-button"
      :on-click #(re-frame/dispatch [::events/refresh-page])
      :text (i18n/get-translation "version_update.critical.refresh_without_saving" "Refresh without saving")}]]
   {:type "warning"
    :id "version-update-notification"
    :auto-close false
    :dismissible false}))

(defn version-update-handler []
  (let [display-type @(re-frame/subscribe [::subs/version-update-display-type])]
    [:div
     (case display-type
       :critical-modal [critical-update-modal]
       :critical-with-unsaved-changes [critical-update-with-unsaved-changes]
       :non-critical-notification [non-critical-update-notification]
       [:<>])]))